/* MT – Interacciones de la marca (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras() {
    var nums = document.querySelectorAll('[data-mt-contar]');
    if (!nums.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-mt-contar')) || 0;
      var dec = (String(fin).split('.')[1] || '').length;
      if (reduce) { el.textContent = fin.toFixed(dec); return; }
      var t0 = null, dur = 1600;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = fin * (1 - Math.pow(1 - p, 3));
        el.textContent = v.toFixed(dec);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initParallax() {
    if (reduce) return;
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var f = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var y = (r.top + r.height / 2 - window.innerHeight / 2) * -f / 100;
        el.style.transform = 'translate3d(0,' + y.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initAltoCabecera() {
    var h = document.querySelector('.section-header');
    if (!h) return;
    function medir() { document.documentElement.style.setProperty('--mt-header-alto', h.offsetHeight + 'px'); }
    medir();
    window.addEventListener('resize', medir);
    if ('ResizeObserver' in window) new ResizeObserver(medir).observe(h);
  }

  function initSlider() {
    document.querySelectorAll('[data-mt-slider]').forEach(function (s) {
      if (s.dataset.mtListo) return;
      s.dataset.mtListo = '1';
      var slides = s.querySelectorAll('[data-mt-slide]');
      var puntos = s.querySelectorAll('[data-mt-punto]');
      if (slides.length < 2) return;
      var seg = parseInt(s.getAttribute('data-mt-intervalo'), 10) || 0;
      var auto = seg > 0 && !reduce;
      s.style.setProperty('--mt-ed-ms', (seg * 1000) + 'ms');
      var i = 0, timer = null;
      function ir(n) {
        slides[i].classList.remove('is-activa'); slides[i].setAttribute('aria-hidden', 'true');
        if (puntos[i]) puntos[i].classList.remove('is-activa');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-activa'); slides[i].setAttribute('aria-hidden', 'false');
        if (puntos[i]) { void puntos[i].offsetWidth; puntos[i].classList.add('is-activa'); }
        programar();
      }
      function programar() { clearTimeout(timer); if (auto) timer = setTimeout(function () { ir(i + 1); }, seg * 1000); }
      puntos.forEach(function (p) { p.addEventListener('click', function () { ir(parseInt(p.getAttribute('data-mt-punto'), 10)); }); });
      var x0 = null;
      s.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      s.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) ir(i + (dx < 0 ? 1 : -1));
      });
      document.addEventListener('shopify:block:select', function (e) {
        var idx = Array.prototype.indexOf.call(slides, e.target);
        if (idx > -1) { auto = false; ir(idx); }
      });
      programar();
    });
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (s) {
      if (s.dataset.mtListo) return;
      s.dataset.mtListo = '1';
      var principal = s.querySelector('[data-mt-principal]');
      var minis = Array.prototype.slice.call(s.querySelectorAll('[data-mt-mini]'));
      var galeria = s.querySelector('[data-mt-galeria]');
      var contador = s.querySelector('[data-mt-contador]');
      var actual = Math.max(0, minis.findIndex(function (m) { return m.classList.contains('is-activa'); }));

      function pintarContador() { if (contador && minis.length > 1) contador.textContent = (actual + 1) + ' / ' + minis.length; }

      var cajaVideo = s.querySelector('[data-mt-video]');
      var video = cajaVideo && cajaVideo.querySelector('video');

      function mostrar(src, mediaId) {
        var idx = minis.findIndex(function (m) { return String(m.dataset.mediaId) === String(mediaId); });
        if (idx > -1) actual = idx;
        minis.forEach(function (m, i) { m.classList.toggle('is-activa', i === actual); });
        pintarContador();
        // Miniatura de vídeo: se reproduce encima de la foto principal
        var esVideo = minis[actual] && minis[actual].hasAttribute('data-mt-es-video');
        if (cajaVideo) {
          cajaVideo.hidden = !esVideo;
          if (esVideo) { var r = video.play(); if (r && r.catch) r.catch(function () {}); }
          else video.pause();
        }
        if (esVideo) { minis[actual].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); return; }
        if (minis[actual]) {
          minis[actual].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
          if (principal) { principal.dataset.zoom = minis[actual].dataset.zoom || src; principal.alt = minis[actual].dataset.alt || principal.alt; }
        }
        if (!principal || !src || principal.getAttribute('src') === src) return;
        principal.classList.add('is-cambiando');
        var img = new Image();
        img.onload = function () { principal.src = src; principal.classList.remove('is-cambiando'); };
        img.src = src;
      }
      function irA(i) {
        if (!minis.length) return;
        actual = (i + minis.length) % minis.length;
        mostrar(minis[actual].dataset.src, minis[actual].dataset.mediaId);
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m.dataset.src, m.dataset.mediaId); }); });
      var ant = s.querySelector('[data-mt-ant]'), sig = s.querySelector('[data-mt-sig]');
      if (ant) ant.addEventListener('click', function (e) { e.stopPropagation(); irA(actual - 1); });
      if (sig) sig.addEventListener('click', function (e) { e.stopPropagation(); irA(actual + 1); });
      pintarContador();

      // Deslizar con el dedo sobre la foto principal
      var lupa = s.querySelector('[data-mt-lupa]');
      var tx = null, ty = null, deslizo = false;
      if (lupa) {
        lupa.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; ty = e.touches[0].clientY; deslizo = false; }, { passive: true });
        lupa.addEventListener('touchend', function (e) {
          if (tx === null) return;
          var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { deslizo = true; irA(actual + (dx < 0 ? 1 : -1)); }
          tx = null;
        });
      }

      // Zoom al pasar el ratón (solo con ratón)
      if (lupa && principal && galeria && galeria.hasAttribute('data-mt-zoom') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        lupa.addEventListener('mouseenter', function () {
          lupa.classList.add('is-zoom');
          if (principal.dataset.zoom && principal.dataset.zoomCargado !== principal.dataset.zoom) {
            var z = new Image(); var url = principal.dataset.zoom;
            z.onload = function () { if (principal.dataset.zoom === url) { principal.dataset.zoomCargado = url; principal.src = url; } };
            z.src = url;
          }
        });
        lupa.addEventListener('mousemove', function (e) {
          var r = lupa.getBoundingClientRect();
          principal.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          principal.style.transform = 'scale(1.9)';
        });
        lupa.addEventListener('mouseleave', function () {
          lupa.classList.remove('is-zoom');
          principal.style.transform = '';
        });
      }

      // Visor a pantalla completa
      var visor = s.querySelector('[data-mt-visor]');
      if (visor && galeria && galeria.hasAttribute('data-mt-ampliar')) {
        document.body.appendChild(visor);
        var vImg = visor.querySelector('[data-mt-visor-img]');
        var escena = visor.querySelector('[data-mt-escena]');
        var vCont = visor.querySelector('[data-mt-visor-contador]');
        var vi = 0, zoomOn = false, foco = null;

        var fuente = function (i) {
          if (minis.length) return { src: minis[i].dataset.zoom, alt: minis[i].dataset.alt || '' };
          return { src: principal ? (principal.dataset.zoom || principal.src) : '', alt: principal ? principal.alt : '' };
        };
        var quitarZoom = function () { zoomOn = false; escena.classList.remove('is-zoom'); vImg.style.transform = ''; vImg.style.transformOrigin = '50% 50%'; };
        var pintar = function () {
          var f = fuente(vi);
          quitarZoom();
          vImg.classList.add('is-cambiando');
          var pre = new Image();
          pre.onload = function () { vImg.src = f.src; vImg.alt = f.alt; vImg.classList.remove('is-cambiando'); };
          pre.src = f.src;
          if (vCont) vCont.textContent = minis.length > 1 ? (vi + 1) + ' / ' + minis.length : '';
          [vi - 1, vi + 1].forEach(function (k) { if (minis.length > 1) { var p = new Image(); p.src = fuente((k + minis.length) % minis.length).src; } });
        };
        var abrir = function () {
          if (deslizo) { deslizo = false; return; }
          vi = actual; foco = document.activeElement;
          visor.hidden = false;
          document.documentElement.classList.add('mt-visor-abierto');
          pintar();
          void visor.offsetWidth;
          setTimeout(function () { visor.classList.add('is-abierto'); }, 20);
          var c = visor.querySelector('.mt-visor__cerrar'); if (c) c.focus();
        };
        var cerrar = function () {
          visor.classList.remove('is-abierto');
          document.documentElement.classList.remove('mt-visor-abierto');
          if (vi !== actual && minis[vi]) mostrar(minis[vi].dataset.src, minis[vi].dataset.mediaId);
          setTimeout(function () { visor.hidden = true; quitarZoom(); }, 380);
          if (foco && foco.focus) foco.focus();
        };
        var mover = function (d) { if (minis.length < 2) return; vi = (vi + d + minis.length) % minis.length; pintar(); };

        if (lupa) lupa.addEventListener('click', abrir);
        var btnAbrir = s.querySelector('[data-mt-abrir]');
        if (btnAbrir) btnAbrir.addEventListener('click', function (e) { e.stopPropagation(); abrir(); });
        visor.querySelectorAll('[data-mt-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
        var va = visor.querySelector('[data-mt-visor-ant]'), vs = visor.querySelector('[data-mt-visor-sig]');
        if (va) va.addEventListener('click', function () { mover(-1); });
        if (vs) vs.addEventListener('click', function () { mover(1); });
        document.addEventListener('keydown', function (e) {
          if (visor.hidden) return;
          if (e.key === 'Escape') cerrar();
          else if (e.key === 'ArrowLeft') mover(-1);
          else if (e.key === 'ArrowRight') mover(1);
        });

        // Zoom dentro del visor: tocar o hacer clic para acercar; mover para recorrer la foto
        var origen = function (x, y) {
          var r = escena.getBoundingClientRect();
          var px = Math.min(100, Math.max(0, (x - r.left) / r.width * 100));
          var py = Math.min(100, Math.max(0, (y - r.top) / r.height * 100));
          vImg.style.transformOrigin = px + '% ' + py + '%';
        };
        var sx = null, sy = null, arrastre = false;
        escena.addEventListener('click', function (e) {
          if (arrastre) { arrastre = false; return; }
          if (zoomOn) { quitarZoom(); return; }
          zoomOn = true; escena.classList.add('is-zoom');
          origen(e.clientX, e.clientY);
          vImg.style.transform = 'scale(2.4)';
        });
        escena.addEventListener('mousemove', function (e) { if (zoomOn) origen(e.clientX, e.clientY); });
        escena.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; arrastre = false; }, { passive: true });
        escena.addEventListener('touchmove', function (e) {
          if (!zoomOn) return;
          e.preventDefault(); arrastre = true;
          origen(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: false });
        escena.addEventListener('touchend', function (e) {
          if (zoomOn || sx === null) return;
          var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { arrastre = true; mover(dx < 0 ? 1 : -1); }
          sx = null;
        });
      }

      // Cantidad
      var cant = s.querySelector('input[name="quantity"]');
      var menos = s.querySelector('[data-mt-menos]'), mas = s.querySelector('[data-mt-mas]');
      if (cant && menos && mas) {
        menos.addEventListener('click', function () { cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) - 1); });
        mas.addEventListener('click', function () { cant.value = Math.min(99, (parseInt(cant.value, 10) || 1) + 1); });
      }

      // Variantes
      var dataEl = s.querySelector('[data-mt-variantes]');
      var textos = {};
      try { textos = JSON.parse(s.querySelector('[data-mt-textos]').textContent); } catch (e) {}
      var variantes = [];
      try { variantes = JSON.parse(dataEl.textContent); } catch (e) {}
      var radios = s.querySelectorAll('[data-mt-opcion]');
      var idInput = s.querySelector('[data-mt-id]');
      var botones = s.querySelectorAll('[data-mt-boton], [data-mt-boton2]');

      function actualizar() {
        var sel = [];
        radios.forEach(function (r) { if (r.checked) sel[parseInt(r.dataset.mtOpcion, 10)] = r.value; });
        radios.forEach(function (r) {
          if (!r.checked) return;
          var e = s.querySelector('[data-mt-valor="' + r.dataset.mtOpcion + '"]');
          if (e) e.textContent = r.dataset.mtEtiqueta || r.value;
        });
        var tituloVar = sel.join(' / ');
        s.querySelectorAll('[data-mt-ficha]').forEach(function (f) { f.hidden = f.getAttribute('data-mt-ficha') !== tituloVar; });
        var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) {
          botones.forEach(function (b) { b.disabled = true; var sp = b.querySelector('span'); (sp || b).textContent = textos.soldout || 'Unavailable'; });
          if (idInput) idInput.disabled = true;
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; }
        s.querySelectorAll('[data-mt-ahora]').forEach(function (e) { e.textContent = v.price; });
        s.querySelectorAll('[data-mt-antes]').forEach(function (e) { if (v.compare) { e.textContent = v.compare; e.hidden = false; } else { e.hidden = true; } });
        var badge = s.querySelector('[data-mt-badge]');
        if (badge) { if (v.off > 0) { badge.textContent = '-' + v.off + '% OFF'; badge.hidden = false; } else { badge.hidden = true; } }
        botones.forEach(function (b) {
          b.disabled = !v.available;
          b.removeAttribute('aria-disabled');
          var sp = b.querySelector('span');
          (sp || b).textContent = v.available ? (textos.add || 'Add to cart') : (textos.soldout || 'Sold out');
        });
        if (v.src) mostrar(v.src, v.media);
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      radios.forEach(function (r) { r.addEventListener('change', actualizar); });

      // Barra fija de compra
      var barra = s.querySelector('[data-mt-barra]');
      var form = s.querySelector('.mt-pp__form');
      if (barra && form && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          var e = en[0];
          var mostrarBarra = !e.isIntersecting && e.boundingClientRect.top < 0;
          barra.classList.toggle('is-visible', mostrarBarra);
          barra.setAttribute('aria-hidden', mostrarBarra ? 'false' : 'true');
        }, { threshold: 0 });
        io.observe(form);
      }
    });
  }

  // Agrega productos al carrito y abre el cajón del carrito
  function agregarAlCarrito(items, btn, error) {
    var drawer = document.querySelector('cart-drawer');
    var raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    if (error) error.hidden = true;
    btn.disabled = true;
    btn.classList.add('is-cargando');
    var datos = { items: items };
    if (drawer) datos.sections = 'cart-drawer,cart-icon-bubble';
    fetch(raiz + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (res) {
        if (drawer && res.sections && typeof drawer.renderContents === 'function') {
          res.id = items[0].id;
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = raiz + 'cart';
        }
      })
      .catch(function () { if (error) error.hidden = false; })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-cargando'); });
  }

  // Botón negro "Buy it now": añade el modelo elegido y la cantidad, y va directo al pago.
  if (!window.mtComprarListo) {
    window.mtComprarListo = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mt-comprar-ya]');
      if (!btn) return;
      e.preventDefault();
      var form = btn.closest('form');
      var idInput = form && form.querySelector('[name="id"]');
      var cantInput = form && form.querySelector('[name="quantity"]');
      if (!idInput || idInput.disabled) return;
      var raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      // Lleva también las propiedades del formulario (diseño de Printify, nota de regalo).
      var propiedades = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (campo) {
        if (!campo.disabled && campo.value) propiedades[campo.name.slice(11, -1)] = campo.value;
      });
      btn.disabled = true;
      btn.classList.add('is-cargando');
      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: Math.max(1, Number(cantInput && cantInput.value) || 1), properties: propiedades }] })
      })
        .then(function (r) { if (!r.ok) throw r; window.location.href = raiz + 'checkout'; })
        .catch(function () { btn.disabled = false; btn.classList.remove('is-cargando'); });
    });
  }

  // Casilla de oferta en el carrito (lateral o página): al marcarla añade el producto.
  // Va con delegación porque el carrito se vuelve a pintar cada vez que cambia.
  if (!window.mtOfertaLista) {
    window.mtOfertaLista = true;
    document.addEventListener('change', function (e) {
      var check = e.target;
      if (!check.matches || !check.matches('.mt-oferta__check') || !check.checked) return;
      var caja = check.closest('[data-mt-oferta]');
      var drawer = check.closest('cart-drawer');
      var raiz = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      if (caja) caja.classList.add('is-cargando');
      check.disabled = true;
      var datos = { items: [{ id: Number(check.dataset.mtOfertaId), quantity: 1 }] };
      if (drawer) datos.sections = 'cart-drawer,cart-icon-bubble';
      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(datos)
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (res) {
          if (drawer && res.sections && typeof drawer.renderContents === 'function') {
            res.id = datos.items[0].id;
            drawer.renderContents(res);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          check.checked = false;
          check.disabled = false;
          if (caja) caja.classList.remove('is-cargando');
        });
    });
  }

  // Combo de regalo: los peines + el regalo elegido. "Complete your ritual": un producto suelto.
  function initGiftSet() {
    document.querySelectorAll('[data-mt-gift-add]').forEach(function (btn) {
      if (btn.dataset.mtListo) return;
      btn.dataset.mtListo = '1';
      btn.addEventListener('click', function () {
        var caja = btn.closest('[data-mt-gift]');
        var elegido = caja && caja.querySelector('[data-mt-gift-regalo]:checked');
        var regalo = elegido ? elegido.value : btn.dataset.regalo;
        agregarAlCarrito([
          { id: Number(btn.dataset.peine), quantity: Number(btn.dataset.cant) },
          { id: Number(regalo), quantity: 1 }
        ], btn, caja && caja.querySelector('[data-mt-gift-error]'));
      });
    });
    document.querySelectorAll('[data-mt-ritual-add]').forEach(function (btn) {
      if (btn.dataset.mtListo) return;
      btn.dataset.mtListo = '1';
      btn.addEventListener('click', function () {
        var caja = btn.closest('[data-mt-ritual]');
        agregarAlCarrito([{ id: Number(btn.dataset.mtRitualAdd), quantity: 1 }], btn, caja && caja.querySelector('[data-mt-ritual-error]'));
      });
    });
  }

  // Botón de promoción junto al modelo: muestra el Gift Set y oculta la compra normal
  function initPromo() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (s) {
      var btn = s.querySelector('[data-mt-promo]'), caja = s.querySelector('[data-mt-promo-caja]');
      if (!btn || !caja || btn.dataset.mtListo) return;
      btn.dataset.mtListo = '1';
      function poner(on) {
        caja.hidden = !on;
        s.classList.toggle('is-promo', on);
        btn.setAttribute('aria-pressed', String(on));
      }
      btn.addEventListener('click', function () { poner(btn.getAttribute('aria-pressed') !== 'true'); });
      s.querySelectorAll('[data-mt-opcion]').forEach(function (r) {
        r.addEventListener('click', function () { poner(false); });
      });
      // Enlaces a #mt-giftset (portada) abren directamente la promoción
      if (location.hash === '#mt-giftset') {
        poner(true);
        setTimeout(function () { caja.scrollIntoView({ block: 'center' }); }, 300);
      }
    });
  }

  // Carrusel de reseñas: una a la vez, con puntos
  function initResenas() {
    document.querySelectorAll('[data-mt-rcar]').forEach(function (car) {
      if (car.dataset.mtListo) return;
      car.dataset.mtListo = '1';
      var pista = car.querySelector('[data-mt-rcar-pista]');
      var puntos = car.querySelectorAll('[data-mt-rcar-punto]');
      puntos.forEach(function (p) {
        p.addEventListener('click', function () {
          pista.scrollTo({ left: pista.clientWidth * Number(p.dataset.mtRcarPunto), behavior: 'smooth' });
        });
      });
      pista.addEventListener('scroll', function () {
        var i = Math.round(pista.scrollLeft / pista.clientWidth);
        puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
      }, { passive: true });
    });
  }

  function init() { initAltoCabecera(); initReveal(); initCifras(); initParallax(); initSlider(); initProducto(); initGiftSet(); initResenas(); initPromo(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
